import React from 'react';
import DashboardCard from './DashboardCard';
import { Col, Row } from 'reactstrap';
import { QUEUE_STATUS } from '../../enums/queueStatus'

const DashboardHeader = ({ data }) => {
    const NO_INFO_TO_DISPLAY = "No information to display";

    let mostRecentlyProcessedFile = (lastProcessedFile) => {
        let cardContent = [];
        if (lastProcessedFile) {
            cardContent.push(<p key='last-processed-file-show' className="mb-0 text-muted text-sm">
                <span className="text-success mr-1">
                    <i className="fas fa-ticket-alt"></i>
                </span>{" "}
                <span className="text-nowrap text-uppercase">{lastProcessedFile.show}</span>
            </p>);
            cardContent.push(<p key='last-processed-file-date' className="mb-0 text-muted text-sm">
                <span className="text-nowrap">{lastProcessedFile.processingEndDate}</span>
            </p>);
        }
        return <DashboardCard
            title="Most Recently Processed File"
            subTitle={lastProcessedFile ? lastProcessedFile.filename : "Last processed file could not be retrieved"}
            iconClass="far fa-copy"
            iconBackground="bg-gradient-success"
        >{cardContent}</DashboardCard>;
    }

    let numberFilesProcessed = (filesProcessedLastHour) => {
        return <DashboardCard
            title="Files Processed on the last hour"
            subTitle={filesProcessedLastHour}
            subTitleClass="h2"
            iconClass="fas fa-clock"
            iconBackground="bg-gradient-primary"></DashboardCard>;
    }

    let percentageOfStatus = (fileStatus) => {
        let cardContent = [];
        if (fileStatus && fileStatus.length > 0) {
            cardContent.push(<Row key='pc-status-row' className="text-center end-radius ml-0 mr-0">
                {fileStatus.map(s => {
                    const { background, name } = QUEUE_STATUS[s.key];
                    let className = `py-2 text-center font-weight-bold text-white bg-${background}`;
                    return <Col key={`pc-status-${name}`} className={className}>{s.value}%
                                <p className="mb-0">{name}</p>
                    </Col>
                })}
            </Row>)
        }
        return <DashboardCard
            title="% of Status"
            subTitle={cardContent.length === 0 && NO_INFO_TO_DISPLAY}>
            {cardContent}
        </DashboardCard>;;
    }

    return (
        <Row className="dashboard-cards">
            <Col lg="6" xl="4" className="mb-2">
                {mostRecentlyProcessedFile(data && data.lastProcessedFile)}
            </Col>
            <Col lg="6" xl="4" className="mb-2">
                {numberFilesProcessed(data ? data.filesProcessedLastHour : 0)}
            </Col>
            <Col lg="12" xl="4" className="mb-2">
                {percentageOfStatus(data && data.fileStatusPercentage)}
            </Col>
        </Row>
    );
}

export default DashboardHeader;